export const COLORS = {
  BORDER: '#E2E6EB',
  GREEN: "#00FF38",
  LIME: "#e2fea4",
  LIGHT: "#f6f6f9",
  SILVER: "#949CA6",
  BLUE: "#0075FF",
  BLACK: "#000",
  NUMBER: "#C3C9D0",
  RED: '#E84747',
  WHITE: "#fff",
} as const;
